import { API_URL } from '@/constants/config';
import { getAuthHeader } from '~/modules/common/utils/cookieUtils';

const base = API_URL + '/v3.5';

/**
 * Feedback Service
 *
 * @param {object} http axios instance from nuxt context
 * @param {object} cookies cookies from nuxt context
 */
export const feedbackService = (http, cookies) => ({
  /**
   * Send Feedback
   *
   * @param {object} params object
   * @param {string} params.name name surname
   * @param {string} params.email email
   * @param {string} params.message message
   * @param {string} params.type type
   * @param {string} params.username username
   * @param {string} params.url url
   *
   */
  async sendFeedback({ name, email, message, type, username, url, thirdPartyIdentifiers } = {}) {
    const params = {
      name,
      email,
      message,
      type,
      username,
      url,
      thirdPartyIdentifiers,
    };
    const { data } = await http.$post(`${base}/feedback`, params, {
      headers: getAuthHeader(cookies),
    });

    return { data };
  },
  /**
   * Send Satisfaction Survey
   *
   * @param {object} params object
   * @param {number} params.experienceLevel experienceLevel
   * @param {number} params.recommendationLevel recommendationLevel
   * @param {string} params.encounteredIssue encounteredIssue
   * @param {string} params.improvementSuggestion improvementSuggestion
   * @param {string} params.name name surname
   * @param {string} params.email email
   * @param {string} params.username username
   * @param {string} params.url url
   *
   */
  async sendSatisfactionSurvey({
    experienceLevel,
    recommendationLevel,
    encounteredIssue,
    improvementSuggestion,
    name,
    email,
    username,
    url,
    thirdPartyIdentifiers,
  } = {}) {
    const params = {
      experienceLevel,
      recommendationLevel,
      encounteredIssue,
      improvementSuggestion,
      name,
      email,
      username,
      url,
      thirdPartyIdentifiers,
    };
    const { data } = await http.$post(`${base}/survey-feedbacks/satisfaction`, params, {
      headers: getAuthHeader(cookies),
    });

    return { data };
  },
});
